module.exports = __webpack_public_path__ + "static/media/rs_600x600-200721041428-600-David-Schwimmer-LT-072120-GettyImages-908307.7ac8dd10.jpg";